import React from "react";
import { Link } from "react-router-dom";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";
import { ArrowRight, Sparkles } from "lucide-react";

const PLANS = [
  { badge: "Every 1 month", title: "The Wardrobe Rotation", body: "A curated 10ml roll-on delivered monthly — chosen from your wardrobe preferences and mood tags. Skip or swap anytime." },
  { badge: "Every 2 months", title: "The Signature Refill", body: "Your chosen 50ml extrait, delivered on a schedule that keeps you from ever running out." },
  { badge: "Quarterly", title: "The Discovery Trio", body: "Three 10ml discovery samples selected to broaden your palette — curated by season and complexity." },
];

const BENEFITS = [
  { badge: "Save 10%", title: "Subscriber pricing", body: "Every subscription order is 10% off the standard retail price of the same product." },
  { badge: "Flexible", title: "Skip, swap, cancel", body: "Pause a delivery, change the fragrance for the next shipment, or cancel entirely — all from your account." },
  { badge: "Priority", title: "First shipped", body: "Subscribers ship before general orders when a new edition drops — no risk of missing a limited release." },
];

const COMING_SOON = [{
  heading: "Coming soon",
  body: "Our subscription service is being finalised. Join our newsletter (footer of every page) and we’ll write to you the day it opens — with founding-member perks reserved for the first cohort.",
}];

const HOW = [{
  heading: "How subscriptions will work",
  body: "When live, subscriptions will be managed directly from your Scentodore account. You’ll be able to choose the plan, cadence, and specific fragrance — and change any of it at any time. There will be no lock-in period and no cancellation fees.\n\nBilling occurs on the same date each cycle, a few days before the shipment leaves our atelier. If you’d like to skip a specific delivery, you’ll have until the day before billing to do so.",
}];

export default function SubscriptionsPage() {
  return (
    <PageShell
      slug="subscriptions"
      testid="subscriptions"
      eyebrow="Subscriptions"
      title="A signature that arrives on schedule."
      intro="Never run out of your favourite Scentodore — or let us curate a monthly rotation for your wardrobe. Fully flexible, cancel anytime."
    >
      <div className="mb-8 flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[#C5A059]">
        <Sparkles className="h-3 w-3" />
        <span>Founding member cohort opening soon</span>
      </div>

      <EditableSection slug="subscriptions" sectionKey="coming_soon" fallback={COMING_SOON} />

      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Planned plans</h2>
        <EditableFeatureGrid slug="subscriptions" sectionKey="plans" fallback={PLANS} />
      </div>

      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Subscriber benefits</h2>
        <EditableFeatureGrid slug="subscriptions" sectionKey="benefits" fallback={BENEFITS} />
      </div>

      <EditableSection slug="subscriptions" sectionKey="how" fallback={HOW} />

      <div className="-mt-8">
        <Link
          to="/contact"
          data-testid="subscriptions-notify-cta"
          className="inline-flex items-center gap-2 bg-[#1A1918] text-[#FAF8F5] px-5 py-3 rounded-xl text-xs uppercase tracking-[0.18em] hover:bg-[#C5A059] hover:text-[#0B0A08] transition-colors"
        >
          Notify me when subscriptions open <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </PageShell>
  );
}
